import { useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { changeLanguage, t } from "i18next";
import { useTranslation } from "react-i18next";

import { createItemRecord, formatMessageEdit } from "utils";
import {
  getSpanishLanguage,
  getHeaderBgColor,
  selectPropertyId,
  selectAPIKey,
  selectIsDisabled,
  setIsSpanishLanguage,
  getAppSSID,
  addNewMessage,
  getIsMaximized,
  selectIsVideoTourScreen,
  selectIsPhotoTourScreen,
  unitSliceData,
  getIsMobileWindow,
} from "slices";
import { LangSwitch } from "components/HeaderBar/LanguageSwitcher/LangSwitch";
import { CustomTooltip } from "components";

export const LanguageSwitcher = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  const isSpanishCurrentLanguage = useSelector(getSpanishLanguage);
  const backgroundColor = useSelector(getHeaderBgColor);
  const propertyId = useSelector(selectPropertyId);
  const apiKey = useSelector(selectAPIKey);
  const SSID = useSelector(getAppSSID);
  const isDisabledOptions = useSelector(selectIsDisabled);
  const isMaximized = useSelector(getIsMaximized);
  const isVideoTourScreen = useSelector(selectIsVideoTourScreen);
  const isPhotoTourScreen = useSelector(selectIsPhotoTourScreen);
  const { isUnitTourScreen } = useSelector(unitSliceData);
  const isMobile = useSelector(getIsMobileWindow);

  const hasWhiteHeaderBg = isMobile || isMaximized || isVideoTourScreen || isPhotoTourScreen || isUnitTourScreen;

  const handleLanguageChange = useCallback(
    (lang) => {
      if (isDisabledOptions) {
        return;
      }

      const isSpanish = lang === "sp";

      if (lang === i18n.language) {
        return;
      }

      // updateLanguage(propertyId, apiKey, isSpanish);
      changeLanguage(lang);

      dispatch(setIsSpanishLanguage(isSpanish));

      // Persist language preference to localStorage
      try {
        localStorage.setItem(`${propertyId}-hayley_language_preference`, lang);
      } catch (error) {
        console.error("Failed to save language preference to localStorage:", error);
      }

      if (isSpanish) {
        dispatch(addNewMessage([{ message: "I now support Spanish too!", speaker: "bot", createdAt: new Date().toISOString() }]));
      }

      formatMessageEdit();

      if (isSpanish) {
        createItemRecord(propertyId, SSID, "spanish conversions");
      }
    },
    [isSpanishCurrentLanguage, propertyId, apiKey, SSID, dispatch, isDisabledOptions]
  );

  useEffect(() => {
    const isSpanishSelected = i18n.language === "sp";

    dispatch(setIsSpanishLanguage(isSpanishSelected));
  }, [dispatch, i18n.language]);

  return (
    <div className="hayley-flex hayley-items-center hayley-gap-3">
      <div className="rounded-[1px] hayley-h-4 hayley-w-px hayley-bg-[#FFFFFF99]" />

      <CustomTooltip title={isSpanishCurrentLanguage ? t("switchToEnglish") : t("switchToSpanish")} placement="bottom">
        <div className="hayley-flex hayley-items-center hayley-gap-2">
          <p className="hayley-m-0 hayley-text-[14px] hayley-font-semibold">Esp</p>
          <div data-testid="language_switcher">
            <LangSwitch
              backgroundColorProp={backgroundColor} // dynamic color from theme
              checked={isSpanishCurrentLanguage}
              onChange={(e) => handleLanguageChange(e.target.checked ? "sp" : "en")}
              thumbColor={backgroundColor}
              hasWhiteHeaderBg={hasWhiteHeaderBg}
            />
          </div>
        </div>
      </CustomTooltip>
      {/* <div data-testid="language_switcher" className="hayley-flex hayley-rounded-[13px] hayley-bg-white hayley-p-[2px]">
        <CustomTooltip title="Switch to English">
          <Box
            component="p"
            data-testid="en_language_switcher"
            className="hayley-m-0 hayley-cursor-pointer hayley-rounded-xl hayley-px-2 hayley-py-[2px] hayley-text-xs hayley-leading-[18px]"
            onClick={() => handleLanguageChange("en")}
            sx={
              isEnglishCurrentLanguage
                ? {
                    backgroundColor,
                    fontWeight: 700,
                    color: "white",
                  }
                : { color: backgroundColor, "&:hover": { backgroundColor: `${backgroundColor}1A` } }
            }
          >
            EN
          </Box>
        </CustomTooltip>

        <CustomTooltip title="Switch to Spanish">
          <Box
            component="p"
            data-testid="es_language_switcher"
            className="hayley-m-0 hayley-cursor-pointer hayley-rounded-xl hayley-px-2 hayley-py-[2px] hayley-text-xs hayley-leading-[18px]"
            onClick={() => handleLanguageChange("sp")}
            sx={
              isSpanishCurrentLanguage
                ? {
                    backgroundColor,
                    fontWeight: 700,
                    color: "white",
                  }
                : { color: backgroundColor, "&:hover": { backgroundColor: `${backgroundColor}1A` } }
            }
          >
            ES
          </Box>
        </CustomTooltip>
      </div> */}
      <div className="rounded-[1px] hayley-h-4 hayley-w-px hayley-bg-[#FFFFFF99]" />
    </div>
  );
};
